import { useTranslation } from 'react-i18next'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCartOutlined'

import { PageContent } from '../../../components/Container'
import MoveRecapBanner from '../../../components/MoveSummaryBanner'
import ContainedPage from '../../../components/layout/ContainedPage'
import { Quotes } from '../../../components/QuoteComponent'
import { Heading, Subtitle } from '../../../components/typography'
import { useCurrentMove, useSelectQuoteAction } from '../../../modules/moves'
import { useErrorFormatter } from '../../../components/errors/useErrorFormatter'
import Spinner from '../../../components/Spinner'
import { errorNotification } from '../../../components/ToastNotifications'
import { type Quote } from '../../../modules/quotes'
import Button, { ButtonSize, ButtonVariant } from '../../../components/Button'

const QuotesPage: React.FC = () => {
  const { t } = useTranslation()
  const move = useCurrentMove()
  const [selectQuote, { loading: selectingQuote }] = useSelectQuoteAction()
  const formatError = useErrorFormatter()

  const onSelectQuote = async (quote: Quote, position: number) => {
    try {
      await selectQuote(quote, position)
    } catch (error) {
      errorNotification(formatError(error))
    }
  }

  return (
    <ContainedPage>
      <PageContent topContent={<MoveRecapBanner />}>
        { selectingQuote && (
          <Spinner floating backdrop />
        ) }
        <div className="mb-12 mt-2 text-center">
          <Heading variant="h1">
            { t('pages.move.quotes.title') }
          </Heading>
          <Subtitle className="lg:text-center">
            { t('pages.move.quotes.subtitleLine1') }
            <br />
            { t('pages.move.quotes.subtitleLine2') }
          </Subtitle>
        </div>

        { move.quotes && (
          <Quotes
            move={move}
            showBest
            customerPerspective
            docTop={70}
            cta={(quote: Quote, position: number) => (
              <Button
                variant={ButtonVariant.Filled}
                size={ButtonSize.Small}
                onClick={async () => { await onSelectQuote(quote, position) }}
                className="md:!mb-[-10px]"
              >
                <ShoppingCartIcon className="mr-[5px] mt-[-5px] !text-[18px]" />
                { t('pages.move.quotes.selectQuote') }
              </Button>
            )}
          />
        ) }

      </PageContent>
    </ContainedPage>
  )
}

export default QuotesPage
